import { setLanguage } from '@/i18n'

export default store => {
  store.subscribe((mutation) => {
    if (mutation.type === 'user/SET_LANGUAGE') {
      const language = store.getters['user/language']
      if (language) {
        setLanguage(language)
      }
    }
  })
}
